import { render } from "./TaskStatusSection.vue?vue&type=template&id=2faa6a34"
import script from "./TaskStatusSection.vue?vue&type=script&lang=js"
export * from "./TaskStatusSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__